import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  doCreateProviderIntegration,
  doDeleteProviderIntegration,
  doGetProviderIntegration,
  doUpdateProviderIntegration,
} from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('provider-integrations') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('provider-integrations') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('provider-integrations') && action.type.endsWith('/rejected');
};

const providerIntegrationsAdapter = createEntityAdapter({
  selectId: (item) => item?.id || item?.keyword, // because default providerIntegrations do not have an id
});

const providerIntegrationSlice = createSlice({
  name: 'providerIntegration',
  initialState: {
    action: null,
    isFetching: false,
    status: 'idle',
    metadata: {},
    entities: [],
    ids: [],
    item: null,
  },
  reducers: {
    clearState: (state) => {
      state.state = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetProviderIntegration.pending, (state) => {
      state.action = 'getOne';
      state.status = 'loading';
    });
    builder.addCase(doGetProviderIntegration.fulfilled, (state, action) => {
      const providerIntegrations = action.payload;
      state.status = 'succeeded';
      providerIntegrationsAdapter.setAll(state, providerIntegrations);
    });
    builder.addCase(doGetProviderIntegration.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreateProviderIntegration.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreateProviderIntegration.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doCreateProviderIntegration.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdateProviderIntegration.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdateProviderIntegration.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdateProviderIntegration.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doDeleteProviderIntegration.pending, (state) => {
      state.action = 'delete';
      state.status = 'loading';
    });
    builder.addCase(doDeleteProviderIntegration.fulfilled, (state, action) => {
      state.status = 'succeeded';
      providerIntegrationsAdapter.removeOne(state, action.meta.arg);
    });
    builder.addCase(doDeleteProviderIntegration.rejected, (state) => {
      state.status = 'failed';
    });

    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const {
  selectAll: selectAllProviderIntegration,
  selectById: selectProviderIntegrationById,
  selectIds: selectProviderIntegrationIds,
} = providerIntegrationsAdapter.getSelectors((state) => state.providerIntegration);

const { actions, reducer: providerIntegrationReducer } = providerIntegrationSlice;
export const { clearState } = actions;
export default providerIntegrationReducer;
